var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.9225 7.77259h-2.5744c-.3321 0-.6643-.24885-.6643-.66359v-4.56215c0-.74653-.9135-1.16128-1.4948-.66359l-5.72998 7.88008c-.5813.58066-.24913 1.57606.58131 1.57606h2.98955c.33218 0 .66435.2488.66435.6635v4.5622c0 .8295.91347 1.2442 1.49477.6636l5.3148-7.79715c.6643-.66359.2491-1.65896-.5813-1.65896z",
    stroke: "#60646c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashEmpty);
export default __webpack_public_path__ + "static/media/flash_empty.e5cfed09737dd26d7b1457ba721eb59d.svg";
export { ForwardRef as ReactComponent };